import React, { FC, ReactElement } from 'react';
import { Box } from '@material-ui/core';
import VariantSelectorItemContainer from '../variantSelectorItem/VariantSelectorItemContainer';
import { GetModelTrimLevel_trimLevelModels } from '../../../../../../trimLevels/graphql/queries/__generated__/GetModelTrimLevel';

export interface IModelListProps {
  models: GetModelTrimLevel_trimLevelModels[];
  selectedVariantId: string;
  selectVariantId: (variantId: string) => void;
  detailsSlot?: ReactElement;
}

const ModelList: FC<IModelListProps> = ({ models, selectedVariantId, selectVariantId, detailsSlot }) => {
  return (
    <Box data-test={'model:list'} width={1}>
      {models?.map((item, id) => (
        <Box
          key={id}
          data-test={`model:selector:${item.model.code}`}
          data-selected={selectedVariantId === item.model.code}
        >
          <VariantSelectorItemContainer
            variantName={item.carConfig.car.attributes.vehicleDisplayName}
            selected={selectedVariantId === item.model.code}
            id={item.model.code}
            selectVariantId={selectVariantId}
            detailsSlot={detailsSlot}
          />
        </Box>
      ))}
    </Box>
  );
};

export default ModelList;
